<template>
  <el-form ref="form" class="priceCus" label-width="140px" :model="form" :rules="rules">
    <el-form-item
      class="priceCus-mgb0"
      v-if="type.type === 'add' && type.cashType !== 2"
      label="可加款现金金额"
    >{{money.addCash}}</el-form-item>
    <!-- <el-form-item
      v-if="type.cashType=== 2 && type.type === 'add'"
      class="priceCus-mgb0"
      label="可加款返货金额"
    >{{money.addGoods}}</el-form-item>-->
    <el-form-item
      class="priceCus-mgb0"
      v-if="type.cashType !== 2"
      :label="!(rowId.user_type === 1 && type.type !== 'add') ? '对方账户的现金余额' : '对方账户的余额'"
    >{{money.cash}}</el-form-item>
    <el-form-item
      class="priceCus-mgb0"
      label="对方账户的返货余额"
      v-if="type.cashType === 2 && type.type !== 'add'"
    >{{money.goods}}</el-form-item>
    <div
      class="priceCus-refund-error"
      v-if="!(type.cashType === 2 || type.type === 'add' || (type.type !== 'add' && (rowId.user_type !== 2 && rowId.user_type !== 3)))"
    >注意：退款将直接清空对方账户全部现金金额、返货金额</div>
    <el-form-item
      :label="type.title"
      prop="price"
      :rules="[{ required: true, message: '请输入金额', trigger: 'blur' }]"
      v-if="type.cashType === 2 || type.type === 'add' || (type.type !== 'add' && (rowId.user_type !== 2 && rowId.user_type !== 3))"
    >
      <!-- <div class="priceCus-type" v-if="rowId.user_type === 3">
        <ny-select
          :data="data"
          v-model="money.type"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          part="publicBank"
          placeholder="请选择"
          class="input-mini"
        ></ny-select>
      </div>-->
      <el-input
        v-model="form.price"
        class="input-sm"
        @input.native="handleChange"
        clearable
        @blur="handleChange"
      ></el-input>
      <div
        class="el-form-item__error"
        v-if="errorShowT && type.type === 'add'"
      >{{this.setMax > 10000000000 ? '不得超过100,000,000,000元' : '预算不足请充值'}}</div>
      <div
        class="el-form-item__error"
        v-if="errorShowT && type.type === 'refund'"
      >{{this.setMax > 10000000000 ? '不得超过100,000,000,000元' : '退款金额不能超过余额'}}</div>
      <div class="el-form-item__error" v-if="errorShowN">请输入整数</div>
    </el-form-item>
    <el-form-item label="备注">
      <el-input
        v-model="form.remark"
        type="textarea"
        :rows="2"
        class="input-lg"
        resize="none"
        autosize
        placeholder="请输入备注信息"
      ></el-input>
    </el-form-item>
    <el-form-item class="formBtn">
      <el-button
        @click="submitForm('form', type.type)"
        :disabled="committing"
      >{{ committing ? '提交中···' : '提交' }}</el-button>
      <el-button class="is-cancel" @click="cancel('form', type.type)">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { comdify, delcommafy } from '@/global/util/util'
import { NySelect } from '@/global/components'
export default {
  data () {
    return {
      form: {
        price: '',
        remark: '',
        type: 1
      },
      errorShowT: '',
      errorShowN: '',
      SetMax: 200,
      oldValue: '',
      rules: {},
      maxBalance: '',
    };
  },
  props: {
    rowId: {
      type: Object,
      default: () => {
        return {
          user_type: ''
        }
      },
      require: false
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    committing: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    platform: {
      type: String,
      require: false
    },
    money: {
      type: Object,
      default: () => {
        return {
          addCash: 'xxxx.xx',
          addGoods: 'xxxx.xx',
          cash: 'xxxx.xx',
          goods: 'xxxx.xx',
          type: 1
        }
      },
      require: false
    },
    type: {
      type: Object,
      require: false
    },
    setMax: {
      type: [Number, String],
      default: () => {
        return 100000000000
      },
      require: false
    },
    errorShow: {
      type: Boolean,
      require: false
    }
  },
  methods: {
    submitForm (formName, handleType) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('surePrice', {            handleType, form: {
              price: delcommafy(this.form.price) ? delcommafy(this.form.price) : 0,
              remark: this.form.remark,
              type: this.money.type
            }          })
        }
      });
    },
    handleChange (val) {
      /* this.$$nextTick(() => {
        if (this.form.price !== null) {
          this.form.price = this.form.price.match(/^\d*(\.?\d{0,2})/g)[0] || null
        }
        if (this.form.price > this.setMax) {
          this.form.price = this.oldValue
          this.errorShowT = true
          return false
        } else {
          this.errorShowT = false
        }
        this.oldValue = this.form.price
        this.$emit('handleChange', val)
      }) */
      this.$nextTick(() => {
        if (this.form.price !== null) {
          this.form.price = comdify(delcommafy(this.form.price), 'float')
        }
        if (delcommafy(this.form.price) > this.setMax) {
          this.form.price = comdify(this.oldValue, 'float')
          this.errorShowT = this.form.price !== ''
          return false
        } else {
          this.errorShowT = false
        }
        this.oldValue = delcommafy(this.form.price)
        this.$emit('handleChange', delcommafy(val))
      })
    },
    /* changeSelect ({ value }) {
      this.form.price = ''
      this.oldValue = ''
      if (this.type.type === 'add') {
        this.maxBalance = value === '1' ? this.money.addCash : this.money.addGoods
        console.log(this.maxBalance, this.money.addCash)
      } else {
        this.maxBalance = value === '1' ? this.money.cash : this.money.goods
      }
    }, */
    cancel (formName, handleType) {
      this.form.price = ''
      this.form.remark = ''
      this.$emit('cancelPrice', { handleType });
    }
  },
  watch: {
    errorShow (newVal) {
      this.errorShowT = newVal
    },
    committing (newVal) {
      if (!newVal) {
        this.form.price = ''
        this.form.remark = ''
      }
    }
  },
  components: {
    NySelect
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.priceCus {
  .input-sm {
    width: 210px;
  }
  .input-lg {
    width: 300px;
  }
  .input-mini {
    width: 100%;
  }
  .priceCus-refund-error {
    color: #ff4949;
    line-height: 30px;
    font-size: 14px;
  }
  .cancel {
    background: #fc8675;
    border-color: #fb5a43;
    width: 50px;
    height: 24px;
    text-align: center;
    color: #fff;
    padding: 0;
  }
  .el-textarea__inner:focus {
    border-color: #2f6599;
  }
  .el-textarea {
    height: auto;
  }
  .priceCus-mgb0 {
    margin-bottom: 0px;
  }
  .priceCus-type {
    width: 140px;
    float: left;
    padding-right: 12px;
    box-sizing: border-box;
    margin-right: 16px;
    display: inline-block;
  }
}
</style>
